<app-invitation-b2b-page-wrapper>
    <ng-container [ngSwitch]="currentInvitationStep">
        <ng-container *ngSwitchCase="invitationStep.invitationB2bInit">
            <ng-container *ngTemplateOutlet="initOrPayment">
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bSelectPayment">
            <ng-container *ngTemplateOutlet="initOrPayment">
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bAccepted">
            <app-invitation-b2b-accepted [invitation]="invitation"
                                         [partnershipId]="partnershipId"
                                         [selectedAccount]="selectedAccount.id"
                                         [type]="'client'"></app-invitation-b2b-accepted>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bRejected">
            <app-invitation-b2b-rejected [invitation]="invitation"
                                         [type]="'client'"></app-invitation-b2b-rejected>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bAlreadyAccepted">
            <ng-container *ngTemplateOutlet="alreadyChecked">
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bAlreadyRejected">
            <ng-container *ngTemplateOutlet="alreadyChecked">
            </ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bSelectAccount">
            <app-invitation-b2b-client-select-account [invitation]="invitation"
                                                      (accountChosen)="onSelectedAccount($event)">
            </app-invitation-b2b-client-select-account>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bOnlyForOwners">
            <app-invitation-b2b-client-only-for-owners [invitation]="invitation">
            </app-invitation-b2b-client-only-for-owners>
        </ng-container>
        <ng-container *ngSwitchCase="invitationStep.invitationB2bWrongAccount">
            <app-invitation-b2b-client-wrong-account [invitation]="invitation">
            </app-invitation-b2b-client-wrong-account>
        </ng-container>
    </ng-container>
</app-invitation-b2b-page-wrapper>
<ng-template #alreadyChecked>
    <app-invitation-b2b-client-already-checked [invitation]="invitation"
                                               [status]="currentInvitationStep">
    </app-invitation-b2b-client-already-checked>
</ng-template>
<ng-template #initOrPayment>
    <div class="invitation">
        <app-header-invitation-b2b-partnership-logos [invitation]="invitation"
                                                     [onlyClient]="currentInvitationStep === invitationStep.invitationB2bSelectAccount"
                                                     [isInverted]="true"
                                                     class="margin-bottom-50">
        </app-header-invitation-b2b-partnership-logos>
        <app-invitation-b2b-client-header-partner-infos [invitation]="invitation">
        </app-invitation-b2b-client-header-partner-infos>
        <mat-card class="invitation__card card">
            <mat-card-content>
                <div class="invitation__access margin-bottom-20">
                    <ng-container [ngSwitch]="currentInvitationStep">
                        <ng-container *ngSwitchCase="invitationStep.invitationB2bInit">
                            <div class="invitation__access--title margin-bottom-50">
                                {{'Confirmez ou modifiez les permissions demandees par $orga$ avant d\'accepter l\'invitation' | transloco: {
                                orga: invitation.account.organization_name
                            } }}
                            </div>
                            <app-invitation-b2b-client-access-list [invitation]="invitation"
                                                                   [selectedAccount]="selectedAccount"
                                                                   (permissionSelected)="onSelectedPermission($event)">
                            </app-invitation-b2b-client-access-list>
                        </ng-container>
                        <ng-container *ngSwitchCase="invitationStep.invitationB2bSelectPayment">
                            <div class="invitation__access--title margin-bottom-25"
                                 [innerHtml]="'$orga$ souhaite <strong>utiliser ses moyens de paiement</strong>.' | transloco: {
                                orga: invitation.account.organization_name
                            }">
                            </div>
                            <ik-info-box [newBg]="true"
                                         [iconClass]="'icon-information'">
                                <span>
                                    <strong>
                                        {{ "Ces moyens de paiement ne pourront etre utilises que pour des commandes et renouvellements de produits Infomaniak." | transloco }}
                                    </strong>
                                </span>
                            </ik-info-box>
                            <app-invitation-b2b-client-payment-list [invitation]="invitation"
                                                                    [selectedAccount]="selectedAccount"
                                                                    (paymentSelected)="onSelectedPayment($event)">
                            </app-invitation-b2b-client-payment-list>
                        </ng-container>
                    </ng-container>
                </div>
                <div class="invitation__buttons text-center margin-top-50">
                    <div class="invitation__buttons--title margin-bottom-30">
                        {{ 'Que souhaitez-vous faire ?' | transloco }}
                    </div>
                    <mat-checkbox class="invitation__buttons--checkbox margin-bottom-30"
                                  color="primary"
                                  *ngIf="selectedPermission === 'limited' || currentInvitationStep ===
                              invitationStep.invitationB2bSelectPayment"
                                  [value]="checkboxConfirm"
                                  (change)="onChangeCheckbox($event)">
                        <span [innerHtml]="getAcceptCheckboxMessage()"></span>
                    </mat-checkbox>
                    <button mat-raised-button
                            [buttonLoader]="rejectLoading"
                            color="danger"
                            (click)="rejectInvitation()">
                        {{ ('Refuser l\'invitation' | transloco) }}
                    </button>
                    <button mat-flat-button
                            *ngIf="selectedPermission === 'limited' || currentInvitationStep === invitationStep.invitationB2bSelectPayment"
                            color="primary"
                            [disabled]="!checkboxConfirm"
                            [buttonLoader]="acceptLoading"
                            (click)="acceptInvitation()">
                        {{ ('Accepter l\'invitation' | transloco) }}
                    </button>
                    <button mat-flat-button
                            *ngIf="selectedPermission === 'full' && currentInvitationStep !== invitationStep.invitationB2bSelectPayment"
                            color="primary"
                            (click)="nextStep()">
                        {{ ('Etape suivante' | transloco) }}
                    </button>
                </div>
            </mat-card-content>
        </mat-card>
    </div>
</ng-template>
